import React, {Component, ReactNode} from 'react'
import {Box, FormControlLabel, Switch} from '@mui/material'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import {AdminDefaultButton, AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {CondominiumInfo, SearchCondition} from '../../condominium/repository/NatGetCondominiumList'
import {CondominiumGroupData} from '../../condominiumGroup/repository/NatGetCondominiumGroup'
import {formatDateTimeForUpdateDate} from '../../../../formatters/formatDate'
import {DO_OR_NOT, SELECT_CONDOMINIUM_TYPE, VALID_OR_NOT_CHECK} from '../../../../CodeMaster'
import PPCheckboxGroup from '../../../../components/shared/forms/PPCheckboxGroup'
import styled from 'styled-components'
import NatCondominiumGroupSelectComponent from '../NatCondominiumGroupSelectComponent'
import {ColumnFlexContainer, FlexGrowContent, RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {Colors, FontSizeInPixel, FontWeights} from '../../../../styledComponents/Constants'
import {AdminDialog} from '../../../../components/shared/pageBaseComponents/AdminDialog'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import {Messages} from '../../../../Messages'
import {Nullable} from '../../../../app/TypeHelpers'
import {AdminPageHeadingArea} from '../../../../components/shared/pageBaseComponents/AdminPageHeadingArea'

interface Props {
    selectCondominiumType: string
    condominiumGroup: CondominiumGroupData
    closeSelectCondominiumDiaLog: () => void
    selectedCondominiumGroupId?: number | null
    loginUserCondominiumGroupId: number | null
    excludeCondominium: CondominiumInfo[]
    hiddenCancelButton?: boolean
    searchCondition: SearchCondition
    condominiums: CondominiumInfo[]
    onlyShowExcludeCondominiums: boolean
    onChangeCondominiumCd: (event: React.ChangeEvent<HTMLInputElement>) => void
    onChangeCondominiumName: (event: React.ChangeEvent<HTMLInputElement>) => void
    onChangeSelectedCondominiumGroupId: (condominiumGroupId: number) => void
    onChangeCondominiumMessageFlag: () => void
    onClickSearchButton: () => Promise<void>
    updateSelectedCondominiumInfo: (selectedCondominiumInfo: CondominiumInfo) => void
    updateSelectedExclusionCondominiumInfo: () => void
    onClickOperationButton: (selectedCondominiumInfo: CondominiumInfo) => void
    onClickDeselectAllExcludeCondominiumsButton: () => void,
    onChangeOnlyShowExcludeCondominiumsSwitch: (event: React.ChangeEvent<HTMLInputElement>) => void
}

interface States {
    isSearchConditionOpen: boolean
    isSearched: boolean
    selectedCondominium: Nullable<CondominiumInfo>
}

export default class NatCondominiumSelectionComponentSp extends Component<Props, States> {
    constructor(props: Props) {
        super(props)

        this.state = {
            isSearchConditionOpen: true,
            isSearched: false,
            selectedCondominium: null,
        }
    }

    onClickSearchConditionTitle = () => {
        if (!this.state.isSearched) {
            return
        }
        this.setState({isSearchConditionOpen: !this.state.isSearchConditionOpen})
    }

    onClickSearchButton = async () => {
        await this.props.onClickSearchButton()
        this.setState({
            isSearchConditionOpen: false,
            isSearched: true,
        })
    }

    onClickCondominiumCard = (condominium: CondominiumInfo) => () => {
        if (this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value) {
            this.setState({selectedCondominium: condominium})
        }
        if (this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value) {
            this.props.onClickOperationButton(condominium)
        }
    }

    onClickConfirmButton = () => {
        if (this.state.selectedCondominium === null) {
            return
        }
        this.props.updateSelectedCondominiumInfo(this.state.selectedCondominium)
    }

    isSelectedCondominium(condominiumCd: string): boolean {
        if (this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value) {
            return this.state.selectedCondominium?.condominiumCd === condominiumCd
        }
        if (this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value) {
            return this.props.excludeCondominium
                .some(condominiumInfo => condominiumInfo.condominiumCd === condominiumCd)
        }
        return false
    }

    renderSearchConditionForm(): ReactNode {
        const selectExcludeCondominiumsType =
            this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value

        return <>
            <SearchConditionForm $open={this.state.isSearchConditionOpen}>
                <SearchConditionItem>
                    <SearchConditionItemTitle>
                        物件コード
                    </SearchConditionItemTitle>
                    <PPTextField
                        InputProps={{
                            inputProps: {
                                maxLength: 6,
                                inputMode: 'numeric',
                            },
                        }}
                        fullWidth
                        onChange={this.props.onChangeCondominiumCd}
                        defaultValue={this.props.searchCondition.condominiumCd}
                    />
                </SearchConditionItem>
                <SearchConditionItem>
                    <SearchConditionItemTitle>
                        物件名
                    </SearchConditionItemTitle>
                    <PPTextField
                        InputProps={{
                            inputProps: {
                                maxLength: 50,
                            },
                        }}
                        fullWidth
                        onChange={this.props.onChangeCondominiumName}
                        defaultValue={this.props.searchCondition.condominiumName}
                    />
                </SearchConditionItem>
                <SearchConditionItem>
                    <SearchConditionItemTitle>
                        物件グループ
                    </SearchConditionItemTitle>
                    <CondominiumGroupSelectWrapper>
                        <NatCondominiumGroupSelectComponent
                            condominiumGroup={this.props.condominiumGroup}
                            defaultValue={
                                (this.props.selectedCondominiumGroupId) ?
                                    this.props.selectedCondominiumGroupId :
                                    this.props.loginUserCondominiumGroupId}
                            onChangeSelectedCondominiumGroupId=
                                {this.props.onChangeSelectedCondominiumGroupId}
                            requiredFlag={true}
                        />
                    </CondominiumGroupSelectWrapper>
                </SearchConditionItem>
                {selectExcludeCondominiumsType && <>
                    <SearchConditionItem>
                        <SearchConditionItemTitle>
                            公開設定
                        </SearchConditionItemTitle>
                        <PPCheckboxGroup
                            data={[{
                                label: '公開中の物件のみを抽出する',
                                checked: this.props.searchCondition.unreleaseCondominiumExclusionFlg
                                    === DO_OR_NOT.DO.value,
                            }]}
                            onChange={this.props.onChangeCondominiumMessageFlag}
                        />
                    </SearchConditionItem>
                </>}
                <FlexGrowContent/>
                <Box height={'16px'}/>
                <AdminDefaultButton
                    fullWidth
                    onClick={this.onClickSearchButton}
                >
                    物件を検索する
                </AdminDefaultButton>
            </SearchConditionForm>
        </>
    }

    renderSearchResult(): ReactNode {
        const selectCondominiumType =
            this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value
        const selectExcludeCondominiumsType =
            this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value

        return <>
            <SearchResultArea>
                <BlockTitle>
                    <div>検索結果（{this.props.condominiums.length}件）</div>
                    <FlexGrowContent/>
                    {this.props.selectCondominiumType ===
                        SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value && <>
                            <div>{`選択中（${this.props.excludeCondominium.length}件）`}</div>
                        </>}
                </BlockTitle>
                <Box height={'8px'}/>
                {this.props.selectCondominiumType ===
                    SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value && <>
                        <CondominiumSelectActionArea>
                            <FormControlLabel
                                control={
                                    <Switch
                                        color={'primary'}
                                        checked={this.props.onlyShowExcludeCondominiums}
                                        onChange={this.props.onChangeOnlyShowExcludeCondominiumsSwitch}
                                    />
                                }
                                label={'選択中の物件のみを表示'}
                                labelPlacement={'start'}
                            />
                            <FlexGrowContent/>
                            <AdminDefaultButton
                                size={'small'}
                                onClick={this.props.onClickDeselectAllExcludeCondominiumsButton}
                            >
                                一括解除
                            </AdminDefaultButton>
                        </CondominiumSelectActionArea>
                    </>}
                <Scroller>
                    {this.renderCondominiums(this.props.condominiums)}
                </Scroller>
                <Box padding={'8px 16px 16px'}>
                    {selectCondominiumType &&
                        <AdminPrimaryButton
                            fullWidth
                            disabled={this.state.selectedCondominium === null}
                            onClick={this.onClickConfirmButton}>
                            確定する
                        </AdminPrimaryButton>
                    }
                    {selectExcludeCondominiumsType &&
                        <AdminPrimaryButton
                            fullWidth
                            onClick={this.props.updateSelectedExclusionCondominiumInfo}
                        >
                            確定する
                        </AdminPrimaryButton>
                    }
                </Box>
            </SearchResultArea>
        </>
    }

    renderCondominiums(condominiums: CondominiumInfo[]): ReactNode {
        if (condominiums.length === 0) {
            return <>
                <Box margin={'8px 16px'}>
                    {Messages.IOPCC0014.toString('')}
                </Box>
            </>
        }

        return <>
            <Box height={'8px'}/>
            {condominiums.map(condominium => {
                const isSelectCondominium = this.isSelectedCondominium(condominium.condominiumCd)
                if (!isSelectCondominium && this.props.onlyShowExcludeCondominiums) {
                    return
                }

                // condominium.releaseFlgは名前に反して非公開フラグの意味
                const isNotReleased = VALID_OR_NOT_CHECK.VALID.value === condominium.releaseFlg
                return (
                    <CondominiumCard
                        key={condominium.condominiumCd}
                        $selected={isSelectCondominium}
                        onClick={this.onClickCondominiumCard(condominium)}
                    >
                        <CondominiumCardHeader>
                            {condominium.condominiumCd}
                            {isNotReleased &&
                                <NotReleasedTag/>
                            }
                            <FlexGrowContent/>
                            更新日時：
                            <Box width={'4px'}/>
                            {formatDateTimeForUpdateDate(condominium.updateDatetime)}
                        </CondominiumCardHeader>
                        <CondominiumCardCondominiumName>
                            {condominium.condominiumName}
                        </CondominiumCardCondominiumName>
                        <div>{condominium.condominiumGroupName}</div>
                    </CondominiumCard>
                )
            })}
        </>
    }

    render(): ReactNode {
        const {isSearched, isSearchConditionOpen} = this.state

        return <>
            <AdminDialog open={true}>
                <PanelArea>
                    <Box padding={'16px'}>
                        <AdminPageHeadingArea
                            title={'物件選択'}
                            onClose={
                                this.props.hiddenCancelButton
                                    ? undefined
                                    : this.props.closeSelectCondominiumDiaLog
                            }
                        />
                    </Box>
                    <BlockTitle onClick={this.onClickSearchConditionTitle}>
                        検索条件
                        {isSearched && (isSearchConditionOpen ?
                                <KeyboardArrowUpIcon/>
                                :
                                <KeyboardArrowDownIcon/>
                        )}
                    </BlockTitle>
                    <SearchConditionFormOverlapArea>
                        {this.renderSearchConditionForm()}
                        {this.renderSearchResult()}
                    </SearchConditionFormOverlapArea>
                </PanelArea>
            </AdminDialog>
        </>
    }
}

const CondominiumCard = styled.div<{ $selected: boolean }>`
  padding: 8px;
  margin: 0 16px 8px;
  border: 1px solid ${Colors.AccentLight};
  border-radius: 4px;
  color: ${Colors.Body};
  ${props => props.$selected && `
    border-color: ${Colors.AdminPrimary}};
    background: rgba(63, 81, 181, 0.10);
  `}
`

const CondominiumCardHeader = styled(RowFlexContainer)`
  font-size: ${FontSizeInPixel.Small}px;
  color: ${Colors.AccentDark};
`

const CondominiumCardCondominiumName = styled.div`
  margin: 4px 0;
  font-size: ${FontSizeInPixel.Body}px;
  font-weight: ${FontWeights.Bold};
`

const NotReleasedTag = styled.div`
  margin-left: 16px;
  display: inline-block;
  width: 64px;
  line-height: 18px;
  border-radius: 9px;
  text-align: center;
  font-size: 12px;
  font-weight: ${FontWeights.Normal};
  color: ${Colors.Surface};
  background: ${Colors.AccentDark};

  &::before {
    content: '非公開';
  }
`

const PanelArea = styled(ColumnFlexContainer)`
  height: 100%;
  align-items: stretch;
  line-height: 1.5;

  .MuiTypography-body1 { //MUIの入力コンポーネントの文字が大きくなるのを防ぐ
    color: unset;
    font-size: unset;
    line-height: unset;
  }

  .MuiCheckbox-root { //チェックボックスの縦幅を抑える
    padding: 0 9px;
  }
`

const SearchConditionFormOverlapArea = styled(FlexGrowContent)`
  position: relative;
`

const BlockTitle = styled(RowFlexContainer)`
  padding: 0 8px;
  height: 37px;
  border-top: 1px solid ${Colors.AccentLight};
  font-size: ${FontSizeInPixel.Middle}px;
  color: ${Colors.AccentDark};
  background: ${Colors.Background};
`

const SearchConditionForm = styled.div<{ $open: boolean }>`
  position: absolute;
  z-index: 1; // 指定しないと検索結果のボタン類が検索条件を突き抜けて表示される
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  padding: 16px;
  background: ${Colors.Surface};
  transform-origin: top;
  transition: all 0.25s;
  ${(props) => props.$open ? `
    transform: scaleY(1);
    opacity: 1;
  ` : `
    transform: scaleY(0);
    opacity: 0;
  `}
`

const SearchConditionItem = styled.div`
  margin-bottom: 16px;
`

const SearchConditionItemTitle = styled.div`
  margin-bottom: 5px;
  font-size: ${FontSizeInPixel.Body}px;
    color: rgba(0, 0, 0, 0.87)
`

const CondominiumGroupSelectWrapper = styled.div`
  .MuiInputBase-root {
    width: 100%;
  }
`

const SearchResultArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const CondominiumSelectActionArea = styled(RowFlexContainer)`
  margin: 0 16px;

  .MuiFormControlLabel-labelPlacementStart { // FormControlLabelのラベルの左側のマージンを消す
    margin-left: 0;
  }
`

const Scroller = styled(FlexGrowContent)`
  overflow-y: scroll;
`
